import { ActionForm } from '../hooks'

export const getDefaultValue = (): ActionForm => {
  return {
    code: '',
    title: '',
    actionCode: null,
    actionTitle: undefined,
    eventTitle: undefined,
    eventCode: null,
    params: '',
    columnToSort: null,
    variable: null,
    json: false,
    jsValue: '',
    objectFormCode: null,
    contextMenu: null,
    targetColumn: null,
    formObject: null,
    command: null,
  }
}
